export { default } from './HighlightHeroIneligible'
